import { SwapVert, TrendingFlat } from '@mui/icons-material';

interface Props {
  sorting?: string | null;
}

export function CustomSortableColumn({ sorting }: Props) {
  return sorting === 'asc' ? (
    <TrendingFlat
      fontSize="small"
      sx={{
        color: 'grey.400',
        transform: 'rotate(-90deg) scaleX(0.8)',
      }}
    />
  ) : sorting === 'desc' ? (
    <TrendingFlat
      fontSize="small"
      sx={{
        color: 'grey.400',
        transform: 'rotate(90deg) scaleX(0.8)',
      }}
    />
  ) : (
    <SwapVert fontSize="small" sx={{ color: 'grey.400' }} />
  );
}
